"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Page404',
  computed: {
    message: function message() {
      return '网管说这个页面你不能进......';
    }
  }
};
exports.default = _default;